import "simplebar-react/dist/simplebar.min.css";
import ShopSimpleBar from "./ShopComponents/ShopSimpleBar";
import ShopHeader from "./ShopComponents/ShopHeader";
import ShopTitle from "./ShopComponents/ShopTitle";
import ShopFavoritesList from "./ShopComponents/ShopFavoritesList";
import MainLink from "../Link";

const ucp_api = `${MainLink()}api/ucp/`;

function UCPShopFaivoritesRender() {
    return (
        <div className="shop-container">
            <ShopHeader typeIndex={1}/>
            <ShopTitle title="Магазин"/>
            <ShopFavoritesList /> {/* Отображаем только избранные элементы */}
        </div>
    );
}

export const ShopFavorites = () => UCPShopFaivoritesRender();